enum ProjectViewMode {
  NONE = 'none',
  CREATE_PROJECT = 'create',
  EDIT_PROJECT = 'edit',
  ADD_USERS = 'add-users',
  ADD_FACILITATORS = 'add-facilitators',
}

export default ProjectViewMode;
